$(function () {
  /**
   * 汎用 チェックボックス一括 On/Off
   */
  (function toggleCheckboxes() {
    var CONTAINER_SELECTOR = '.js-check-all-container';
    var TOGGLE_SELECTOR = '.js-check-all';
    var TOGGLE_CLASS = 'js-check-all';

    var $container = $(CONTAINER_SELECTOR);
    var $toggle = $(TOGGLE_SELECTOR);

    if ($container.length && $toggle.length) {
      $container.find('[type="checkbox"]').each(function () {
        var $checkbox = $(this);

        if ($checkbox.hasClass(TOGGLE_CLASS)) {
          // 一括選択トグル
          $checkbox.on('click', function () {
            if ($(this).prop('checked')) {
              // On
              $container.find('[type="checkbox"]').prop('checked', true);
            } else {
              // Off
              $container.find('[type="checkbox"]').prop('checked', false);
            }
          });
        } else {
          // 個別チェックボックス
          $checkbox.on('click', function () {
            if (!$(this).prop('checked')) {
              // 一括 Off
              $toggle.prop('checked', false);
            }
          });
        }
      });
    }
  })();
});